import UserPreferences from './UserPreferences';

export default UserPreferences;
